// ----------------------------------------------------------------------
// Stripe Connect Translations - English
// ----------------------------------------------------------------------

export const stripeConnectEn = {
  stripe_connect: {
    // Account selector
    select_account: 'Select Stripe Account',
    destination_account: 'Destination Account',
    no_accounts_available: 'No Stripe accounts available for transfers. Please configure a Stripe account in organization settings.',
    personal_account: 'Personal Account',
    organization_account: 'Organization Account',
    transfer_destination: 'Transfer Destination',
    transfer_helper_text: 'The owner share will be transferred to this account after the event',
    select_account_for_transfer: 'Select which Stripe account should receive the owner share',

    // Account status
    status_active: 'Active',
    status_pending: 'Pending',
    status_inactive: 'Inactive',

    // Alerts and messages
    legal_verification: 'Legal Verification Required',
    complete_stripe_setup: 'Complete Stripe Setup',
    complete_setup_short: 'Complete Setup',
    setup_stripe_account: 'Setup Stripe Account',
    setup_short: 'Setup Stripe',
    alert_stripe_incomplete_setup: 'Your Stripe account setup is incomplete. Please complete the verification to receive payments.',
    alert_stripe_configuration_title: 'A Stripe Connect account is required to receive payments for your events.',

    // Multi-account messages
    no_stripe_for_org: 'No Stripe Account for This Organization',
    no_stripe_for_org_named: 'No Stripe Account for "{{orgName}}"',
    using_personal_account_disclaimer: 'Using your personal Stripe account.',
    configure_org_account: 'Set up organization account',
    has_stripe_on_other_orgs: 'You have Stripe accounts on other organizations. Configure this organization to use an existing account or create a new one in organization settings.',
    has_legacy_account: 'You have a personal Stripe account. Enable it for this organization or create a new one in organization settings.',
    configure_in_settings: 'Configure in Settings',
    setup_in_org_settings: 'Please set up Stripe accounts in organization settings',
    personal_account_available: 'Personal Stripe Account Available',
    personal_account_hint: 'You have a personal Stripe account that can be enabled for "{{orgName}}". Go to organization settings to configure payment accounts.',
    org_setup_incomplete_personal_available: 'Organization Payment Setup Incomplete',
    org_setup_incomplete_personal_hint: 'The Stripe setup for "{{orgName}}" is not complete yet. Your personal account is being used in the meantime. Complete the organization setup when convenient.',
    alert_stripe_incomplete_setup_org: 'The Stripe account setup for "{{orgName}}" is incomplete. Please complete the verification process to start receiving payments for your events.',
    alert_stripe_configuration_org: 'To receive payments for events in "{{orgName}}", you need to set up a Stripe Connect account. This is required for legal compliance and secure payment processing.',

    // Stripe accounts manager
    stripe_accounts: 'Stripe Accounts',
    stripe_accounts_subtitle: 'Manage Stripe Connect accounts for this organization',
    add_account: 'Add Account',
    add_new_account: 'Add New Account',
    sync_account: 'Sync Account',
    set_as_primary: 'Set as Primary',
    deactivate_account: 'Deactivate Account',
    edit_account: 'Edit Account',
    account_name: 'Account Name',
    account_description: 'Description',
    account_name_placeholder: 'e.g., Main Account, Festival Account',
    account_description_placeholder: 'Optional description for this account',
    primary_account: 'Primary Account',
    primary_account_badge: 'Primary',

    // Account stats
    total_accounts: 'Total Accounts',
    active_accounts: 'Active Accounts',
    pending_accounts: 'Pending Accounts',
    inactive_accounts: 'Inactive Accounts',

    // Account details
    account_id: 'Account ID',
    charges_enabled: 'Charges Enabled',
    payouts_enabled: 'Payouts Enabled',
    details_submitted: 'Details Submitted',
    country: 'Country',
    currency: 'Currency',
    business_type: 'Business Type',
    last_synced: 'Last Synced',
    created_at: 'Created At',
    created_by: 'Created By',

    // Actions
    complete_onboarding: 'Complete Onboarding',
    view_dashboard: 'View Stripe Dashboard',
    refresh_status: 'Refresh Status',

    // Confirmations
    confirm_deactivate: 'Are you sure you want to deactivate this account?',
    confirm_deactivate_description: 'Deactivated accounts cannot receive payments. You can reactivate them later.',
    confirm_set_primary: 'Set this account as primary?',
    confirm_set_primary_description: 'The primary account will be used by default for new events.',

    // Success messages
    account_created: 'Stripe account created successfully',
    account_updated: 'Stripe account updated successfully',
    account_synced: 'Account status synced successfully',
    account_deactivated: 'Account deactivated successfully',
    primary_account_set: 'Primary account updated successfully',

    // Error messages
    error_creating_account: 'Error creating Stripe account',
    error_updating_account: 'Error updating Stripe account',
    error_syncing_account: 'Error syncing account status',
    error_deactivating_account: 'Error deactivating account',
    error_setting_primary: 'Error setting primary account',
    error_creating_stripe_link: 'Error creating Stripe onboarding link',
    error_creating_stripe_account: 'Error creating Stripe account',

    // Legacy account
    use_legacy_account: 'Use Personal Account',
    use_legacy_account_description: 'Fall back to your personal Stripe account when no organization account is available',
    legacy_account_active: 'Your personal Stripe account is active and can be used',
    legacy_account_pending: 'Your personal Stripe account requires additional verification',
  },

  // Shares distribution (new keys - existing keys like shares_distribution, reservation_details, reservations are in main locale)
  shares_distribution_subheader: 'Overview of revenue distribution for this event',
  total_sales: 'Total Sales',

  // Common
  this_organization: 'this organization',
};

export default stripeConnectEn;
